
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's0c3b1fef418d5b74': `.`,
's132522bb7aae8035': `Reisebüro suchen`,
's18478448b60cf9cf': `Für den Fall, dass keine Buchung erfolgt, akzeptiere ich eine Beratungspauschale von CHF 150.– (voll anrechenbar bei Buchung).`,
's1939b4eadf354f4f': `Ein notwendiges Script (Google reCAPTCHA) konnte nicht geladen werden. Bitte überprüfen Sie ihre Einstellungen.`,
's1ded3fc62d4f8519': `Ihre Daten bearbeiten wir gemäss unserer `,
's23b0aab96e8df173': `Uhr`,
's316b0adbe5a78346': `Wählen Sie die passende Uhrzeit für Ihren Termin.`,
's332ab4f9597c80af': `Vorname`,
's3a09134dbe99ca77': `Datum wählen`,
's3d1affb5392426a7': `Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`,
's456078dbb63e9c46': `Telefon`,
's4f78b4b59795bc5e': `Per Telefon`,
's51a82303f3cba908': `Ich möchte den personalisierten Newsletter zu eigenen und Partner-Produkten gemäss der Datenschutzerklärung erhalten. Diese Einwilligung kann jederzeit mit Wirkung für die Zukunft über den Abmeldelink im Newsletter widerrufen werden.`,
's595a9a3948ff6918': `E-Mail`,
's5e73f98199ac0dec': `Telefon`,
's5f48682995b76e99': `Frau`,
's62a24ababe044eac': `Wie dürfen wir Sie beraten?`,
's64361086e22178a8': `So stelle ich mir meine Reise vor`,
's6e96f924f8fde70e': `Im Reisebüro`,
's795bfd73603118ed': `Bitte beachten Sie, dass Ihr Beratungstermin erst mit unserer Rückbestätigung verbindlich ist. Wir melden uns zeitnah bei Ihnen und freuen uns darauf, Sie bei uns zu begrüssen.`,
's84f56833762a8dde': `Wählen Sie ein passendes Datum.`,
's979e005caa23191c': `Per Videocall`,
's98810821fd49d570': `Herr`,
's9d70decbe00ecee5': `Datenschutzerklärung`,
's9eae752ec1d6eaed': `Wecken Sie Ihr Fernweh – schon bald geht es los mit der Planung Ihrer persönlichen Traumreise.`,
'sa2cda9e57e677b1a': `Lassen Sie uns gemeinsam aus Ihren Ferienträumen Traumferien machen – wo, wann und wie es Ihnen am besten passt.`,
'sbde2c889ca41987f': `Ihre Kontaktdaten`,
'sc0f2e2a0357d674b': `Kontaktdaten`,
'sc288aaa98d1d805f': `Anrede`,
'sc38a7808b5c16b9e': `Beratungstermin buchen`,
'sc78f6722e16a6915': `Divers`,
'sc8b4b07c3d153566': `Bitte wählen`,
'sd1ae39c808c62dc1': `Nachname`,
'sd6be36b3da2b363e': `Bei Rückfragen zum Beratungstermin, kontaktieren Sie mich bitte per`,
'sd8df04bd3cea1743': `Senden`,
'sdfd268b3ab4f11bb': `E-Mail bestätigen`,
'se2be8581e4931555': `Wählen Sie Ihr Reisebüro`,
'sed9254d62dad0502': `E-Mail`,
'sf22261518dcb241a': `Ihr Wunschtermin`,
'sf470f1e814975856': `Termin wählen`,
'sfc2b2254de1bc4e8': `Herzlichen Dank für Ihre Anfrage`,
    };
  